import L from 'leaflet';
import icon from '../../../assets/venue_location_icon.svg';


export const createTrafficLightIcon = (bearing = 0) => {
  return L.divIcon({
    className: 'leaflet-venue-icon-container',
    html: `<div style="transform: rotate(${bearing}deg); width: 35px; height: 35px; display: flex; justify-content: center; align-items: center;">
             <img src="${icon}" style="width: 100%; height: 100%; display: block;" alt="Traffic Light" />
           </div>`,
    iconSize: [35, 35],
    iconAnchor: [17.5, 17.5], // Center anchor (half of 35)
  });
};
